import { PATHS } from "@/routing/paths"

export const getPeopleLinkSheet = <TPeople extends { id: string }>(people?: TPeople | null) => {
  return `${PATHS.CUSTOMERS}/${people?.id ?? "0"}`
}
